import React, { useState, useEffect } from "react";
const updateMathContent = (s) => {

    // eslint-disable-next-line no-undef
    global.MathJax.Hub.Queue(["Typeset", global.MathJax.Hub]);
}
// eslint-disable-next-line react/prop-types
const RawHtml = ({ html, triggerMathjax = true, containerStyle = {} }) => {
    useEffect(() => {
        if (triggerMathjax) {
            updateMathContent()
        }
    })
    const copySafeHtml = `<div onmousedown='return false;' onselectstart='return false;'>${html}</div>`
    return (<div onContextMenu={(e)=>{e.preventDefault(); return false;}} style={{ paddingLeft: "20px",display:"contents", ...containerStyle }}><div dangerouslySetInnerHTML={{ __html: copySafeHtml }} /></div>)
}

export default RawHtml;